import dateFormat from "dateformat";

export const formatBoolean = (value) => {
  if (value === true) return "კი";
  if (value === false) return "არა";
  return "-";
};

export const resolveIdToName = (value, options) => {
  if (typeof value === "object" && value !== null) {
    if (value.settlement) return String(value.settlement);
    if (value.municipality) return String(value.municipality);
    if (value.name) return String(value.name);

    const idToFind = value._id;
    if (idToFind && options && Array.isArray(options)) {
      const found = options.find((opt) => opt.value === idToFind || opt._id === idToFind);
      if (found) return String(found.label || found.name);
    }
    return String(idToFind || "");
  }

  if (!value) return String(value ?? "");

  if (options && Array.isArray(options)) {
    const found = options.find((opt) => opt.value === value || opt._id === value);
    if (found) return String(found.label || found.name);
  }

  return String(value);
};

export const formatFieldValue = (value, fieldConfig, generalInfo) => {
  if (value === undefined || value === null || value === "") return "-";
  if ((fieldConfig.type === "text" || fieldConfig.type === "textarea") && typeof value === "string") return value;
  if (fieldConfig.type === "number" && typeof value === "number") return value.toLocaleString ? value.toLocaleString() : value;

  switch (fieldConfig.type) {
    case "date":
      try {
        return dateFormat(value, "yyyy-mm-dd", "T");
      } catch (e) {
        return "Invalid Date";
      }
    case "checkbox":
      return formatBoolean(value);
    case "select":
    case "autocomplete":
      let options = fieldConfig.options;
      if (typeof options === "function") {
        if (Array.isArray(value)) {
          return (
            value
              .map((v) => {
                if (typeof v === "object" && v !== null) {
                  if (v.activity_code && v.activity_description) {
                    return `${v.activity_code} ${v.activity_description}`;
                  }
                  return String(v.settlement || v.name || v.municipality || v.label || v._id || "");
                }
                return String(v);
              })
              .join(", ") || "-"
          );
        }

        if (typeof value === "object" && value !== null) {
          if (value.activity_code && value.activity_description) {
            return `${value.activity_code} ${value.activity_description}`;
          }
          return String(value.settlement || value.municipality || value.name || value.label || value._id || "");
        }

        return String(value);
      }
      if (Array.isArray(value)) return value.map((val) => resolveIdToName(val, options)).join(", ") || "-";
      return resolveIdToName(value, options);
    case "number":
      return typeof value === "number" && value.toLocaleString ? value.toLocaleString() : value;
    default:
      return String(value);
  }
};
